export default __webpack_public_path__ + "ff1f0115888f082bc5e4dd479ca5d100.jpg";